import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgTablet = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.009 2h11.983c.55 0 1.007 0 1.38.03.39.032.753.1 1.096.276.527.269.957.698 1.226 1.226.175.343.244.707.276 1.096.03.373.03.83.03 1.377v11.99c0 .548 0 1.004-.03 1.377-.032.39-.1.753-.276 1.096-.269.528-.698.957-1.226 1.226-.343.175-.707.244-1.096.276-.373.03-.83.03-1.38.03H6.008c-.55 0-1.008 0-1.381-.03-.39-.032-.753-.1-1.096-.276a2.8 2.8 0 0 1-1.226-1.226c-.175-.343-.244-.707-.276-1.096C2 19 2 18.542 2 17.992V6.008c0-.55 0-1.007.03-1.38.032-.39.1-.753.276-1.096a2.8 2.8 0 0 1 1.226-1.226c.343-.175.707-.244 1.096-.276C5 2 5.458 2 6.008 2m-1.26 1.526c-.296.024-.44.067-.536.116a1.3 1.3 0 0 0-.57.57c-.05.097-.093.242-.117.538-.025.305-.026.7-.026 1.289V17.96c0 .588 0 .984.026 1.29.024.296.067.44.116.536.126.246.325.446.57.57.097.05.241.093.538.117.305.025.701.026 1.29.026H17.96c.588 0 .984 0 1.29-.026.295-.024.44-.067.536-.116.246-.126.446-.326.57-.57.05-.097.093-.241.118-.538.024-.305.025-.7.025-1.289V6.04c0-.588 0-.984-.025-1.29-.025-.296-.068-.44-.117-.536a1.3 1.3 0 0 0-.571-.57c-.097-.05-.24-.093-.537-.117-.305-.025-.7-.026-1.289-.026H6.04c-.588 0-.984 0-1.29.026m6.501 14.64a.75.75 0 0 1 .75-.75h.002a.75.75 0 0 1 .75.768v.002a.75.75 0 0 1-.745.733h-.002a.75.75 0 0 1-.755-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgTablet;
